import type {
  EdgeId,
  PathLookupDeviceDecisions,
  ReportSeverity,
} from '@ipfabric/utils';

export const getPacketSeverityInfo = (
  sourcePacketId: EdgeId | undefined,
  targetPacketId: EdgeId,
  decision?: PathLookupDeviceDecisions,
): Record<ReportSeverity, number> | undefined => {
  const tracesForInspection = decision?.traces.find(
    (trace) =>
      trace.sourcePacketId === sourcePacketId &&
      trace.targetPacketId === targetPacketId,
  );
  return tracesForInspection?.severityInfo;
};
